import axios from 'axios';
import type { AxiosResponse, AxiosError } from 'axios';
import { LOGIN } from 'routes';
/**
 * Centralized Axios instance for API calls.
 * Sets baseURL, credentials, and intercepts 401 errors to redirect to login.
 */
const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
});
apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    // Allow requests to skip auth redirect by setting header 'X-Skip-Auth-Redirect'
    // Grab request config, trusting it may have headers
    const config: any = error.config || {};
    const headers: Record<string, any> = config.headers || {};
    const skipRedirect = headers['x-skip-auth-redirect'] || headers['X-Skip-Auth-Redirect'];
    if (status === 401 && !skipRedirect) {
      const { pathname, search, hash } = window.location;
      // Do not redirect if already on a login-related page
      if (!pathname.startsWith(LOGIN)) {
        const from = encodeURIComponent(pathname + (search || '') + (hash || ''));
        window.location.href = `${LOGIN}?from=${from}`;
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
